// extracted by mini-css-extract-plugin
export default {"table-scroll":"investment-holdings-real-estate_table-scroll__PBL3G"};